import {FamiliesService} from "../families.service";
import {Injectable} from "@angular/core";
import {Http, URLSearchParams} from "@angular/http";
import {UrlService} from "../url.service";
import {AuthentService} from "../authent.service";
import {Observable} from "rxjs";
import {Tweet} from "../../model/social/tweet";
import {TweetWall} from "../../model/social/tweet-wall";

@Injectable()
export class TweetService extends FamiliesService {

  constructor(private http: Http, private urlService: UrlService, private authent: AuthentService) {
    super();
  }

  getLastTweets(eventId: number, date: number): Observable<Array<Tweet>> {
    let params:URLSearchParams = new URLSearchParams();
    params.set('date', String(date));

    let options = this.authent.getJSONAuthentHeaders();
    options.search = params;

    return this.http.get(this.urlService.getLastTweetsUrl(eventId), options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteTweet(eventId: number, tweetId: number) {
    return this.http.delete(this.urlService.getTweetDeleteUrl(eventId, tweetId), this.authent.getAuthentHeaders())
      .catch(this.handleError)
  }

  getTweetWall(eventId: number): Observable<TweetWall> {
    return this.http.get(this.urlService.getTweetWallUrl(eventId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  updateTweetWall(eventId: number, tweetWall: TweetWall): Observable<TweetWall> {
    return this.http.put(this.urlService.getTweetWallUrl(eventId), tweetWall, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteLogo(eventId: number, index: number) {
    return this.http.delete(this.urlService.getTweetWallLogoAddUrl(eventId, index), this.authent.getAuthentHeaders())
      .catch(this.handleError)
  }

  deleteBackground(eventId: number) {
    return this.http.delete(this.urlService.getTweetWallAddBackgroundUrl(eventId), this.authent.getAuthentHeaders())
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/tweet.service.ts